const TEST_IDS = {
  swapDetails: 'swap-details',
};

export default TEST_IDS;
